export default __webpack_public_path__ + "static/media/pokeball-yellow.4e0daf8a.svg";